import { render, staticRenderFns } from "./PhotoCollection.vue?vue&type=template&id=9cfcae52&scoped=true&"
import script from "./PhotoCollection.vue?vue&type=script&lang=js&"
export * from "./PhotoCollection.vue?vue&type=script&lang=js&"
import style0 from "./PhotoCollection.vue?vue&type=style&index=0&id=9cfcae52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfcae52",
  null
  
)

export default component.exports